import classNames from 'classnames';
import { PropTypes } from 'react';

const FilterBar = ({ children, style, isOpen }) => {
    const classes = classNames(
        { 'cn-filterbar': true },
        { 'cn-filterbar--is-open': isOpen }
    );
    return (
        <div className={classes}>
            <div className="cn-filterbar__carat" style={style} />
            {children}
        </div>
    );
};

FilterBar.propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    style: PropTypes.objectOf(PropTypes.string)
};


export default FilterBar;



// WEBPACK FOOTER //
// ./app/tickets/components/filter-bar.jsx